import React, { useContext, useEffect, useRef } from 'react';
import dayjs from 'dayjs';

import userTypes from "venuescanner-js/constants/user_type";
import { ViewContext } from "venuescanner-js/react/components/Inbox/context/ViewContext";
import { type } from "venuescanner-js/constants/thread";

import AutomatedMessage from 'venuescanner-js/react/components/Inbox/components/Chat/AutomatedMessage';
import MessageDate from 'venuescanner-js/react/components/Inbox/components/Chat/MessageDate';
import { MemoizedMessage } from 'venuescanner-js/react/components/Inbox/components/Chat/Message';

const messageTypes = [type.MSG, type.MESSAGE];
const Dialogue = ({ thread }) => {
  const messagesRef = useRef(null);
  const messagesRefContainer = useRef(null);
  const messageReadIndicatorRef = useRef(null);
  const { threadLoading, chatFilter } = useContext(ViewContext);
  const isHost = thread.viewerRole === userTypes.host;

  const setLastUnreadMsg = () => {
    messageReadIndicatorRef.current.style.bottom = '2px';
    for (let i = 0; i < thread.messages.length; i++) {
      if (
        thread.messages[i].msg !== '' &&
        !thread.messages[i][isHost ? 'org_status_web' : 'host_status_web']
      ) {
        const messageNode = document.querySelector(
          `[data-message="${thread.messages[i - 1 >= 0 ? i - 1 : i]._id}"]`,
        );
        if (messageNode) {
          messageReadIndicatorRef.current.style.bottom =
            messagesRefContainer.current.offsetHeight -
            (messageNode.offsetTop + messageNode.offsetHeight) +
            'px';
        }
        break;
      }
    }
  };

  let previousOffer = null;
  const cumulative = {
    paid: 0,
    outstanding: thread.priceInPence / 100,
  };
  const messages = thread
    ? thread.messages.map((message, index) => {
        const isEmptyModify = false;
        const addMessageDate =
          index > 0 && !isHost
            ? dayjs(thread.messages[index - 1].sendAt).format('DD MM YYYY') !==
              dayjs(message.sendAt).format('DD MM YYYY')
            : true;
        const isAutomatedMessage = !messageTypes.includes(message.type);
        // console.log(message.type, offerStatus, isAutomatedMessage, isEmptyModify)
        const isCallFeedback = message.type === type.CALL;
        const content = isEmptyModify ? null : chatFilter !== null ? (
          message.msg.toLowerCase().search(chatFilter.toLowerCase()) !== -1 && (
            <MemoizedMessage
              key={message._id}
              thread={thread}
              message={message}
            />
          )
        ) : !isCallFeedback &&
          (message.msg.length > 1 || message.attachments.length > 0) ? (
          <div key={message._id} className='chat-messages__wrapper'>
            {addMessageDate && (
              <MessageDate
                showDetailedDate={isHost}
                date={message.sendAt}
                spacingTop={index > 0}
              />
            )}
            {isAutomatedMessage && (
              <AutomatedMessage
                message={message}
                previousOffer={previousOffer}
                cumulative={cumulative}
                thread={thread}
              />
            )}
            <MemoizedMessage thread={thread} message={message} />
          </div>
        ) : (
          <div key={message._id}>
            {addMessageDate && (
              <MessageDate
                showDetailedDate={isHost}
                date={message.sendAt}
                spacingTop={index > 0}
              />
            )}
            {isAutomatedMessage && (
              <AutomatedMessage
                message={message}
                previousOffer={previousOffer}
                cumulative={cumulative}
                thread={thread}
              />
            )}
          </div>
        );
        if (message?.offer?.dates) previousOffer = message.offer;
        return content;
      })
    : null;

  useEffect(() => {
    if (
      !threadLoading &&
      thread?.messages?.length !== 0 &&
      chatFilter === null
    ) {
      messagesRef.current.scrollTop = messagesRefContainer.current.scrollHeight;
      setLastUnreadMsg();
    }
  }, [messages]);

  return (
    <div className='chat-messages' ref={messagesRef}>
      <div className='chat-messages__container' ref={messagesRefContainer}>
        {chatFilter === null && messages.length !== 0 && (
          <div
            ref={messageReadIndicatorRef}
            className='chat-messages__indicator'>
            <span className='chat-messages__indicator__solid' />
          </div>
        )}
        {messages}
        {chatFilter !== null &&
          messages.sort()[0] === messages[messages.length - 1] && (
            <p className='chat__search__no-results'>No messages found</p>
          )}
      </div>
    </div>
  );
};

export default Dialogue;
